import { render, staticRenderFns } from "./PreviewLabelValue.vue?vue&type=template&id=99bbbeb8"
import script from "./PreviewLabelValue.vue?vue&type=script&lang=ts"
export * from "./PreviewLabelValue.vue?vue&type=script&lang=ts"
import style0 from "./PreviewLabelValue.vue?vue&type=style&index=0&id=99bbbeb8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports